export default class TotalVsdModal {
  totalPlaned: number | undefined;
  billablePlaned: number | undefined;

  constructor(data: TotalVsdModal) {
    this.totalPlaned = data.totalPlaned;
    this.billablePlaned = data.billablePlaned;
  }
}
